import { Component, OnInit } from "@angular/core";
import { AppService } from "../services/app.service";
import { SupportService } from "../services/support-service";
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-message-center",
  templateUrl: "./message-center.component.html",
})
export class MessageCenterComponent implements OnInit {
  fromDate: string;
  data: any;
  toDate: string;
  preAuthorizedtodayCount: number;
  nonAuthorizedtodayCount: number;
  nonAuthorizedtmrwCount: number;
  preAuthorizedtmrwCount: number;
  patientCancelledCount: number;
  rescheduledCount: number;
  patientNoShowCount: number;
  icCancelledCount: number;
  selectedTab = "";
  isUSBased = false;

  get patientAppointmentsTodayCount(): number {
    return (this.preAuthorizedtodayCount || 0) + (this.nonAuthorizedtodayCount || 0);
  }

  get patientAppointmentsTmrwCount(): number {
    return (this.preAuthorizedtmrwCount || 0) + (this.nonAuthorizedtmrwCount || 0);
  }

  constructor(
    private appService: AppService,
    private supportService: SupportService,
    private location: Location,
    private router: Router
  ) {}

  ngOnInit() {
    this.selectedTab = sessionStorage.getItem("currentTab")
      ? sessionStorage.getItem("currentTab")
      : "today";

    // Check if image center is US-based (countryId = 2)
    const countryId = localStorage.getItem("countryId");
    this.isUSBased = countryId === "2";

    this.checkselectedtab(this.selectedTab);
  }

  checkType(type) {
    if (type === "today") {
      sessionStorage.setItem("selectedDate", "today");
    } else {
      sessionStorage.setItem("selectedDate", "tomorrow");
    }
  }

  redirectToAuthorization(preauthauth, type) {
    sessionStorage.setItem("fromMessagecentre", "true");
    if (preauthauth === "yes") {
      sessionStorage.setItem("preauth", "Yes");
      this.checkType(type);
    }
    if (preauthauth === "no") {
      sessionStorage.setItem("preauth", "No");
      this.checkType(type);
    }
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "authorization-status",
    ]);
  }

  redirectToCancelAppointment(type) {
    if (type === "patient") {
      sessionStorage.setItem("canceledBy", "Patient");
    } else {
      sessionStorage.setItem("canceledBy", "Ic");
    }
    sessionStorage.setItem("fromMessagecentre", "true");
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "cancelled-report",
    ]);
  }

  redirectToNoshow() {
    sessionStorage.setItem("fromMessagecentre", "true");
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "noshow-patient",
    ]);
  }

  checklength(value) {
    if (value && value.toString().length > 1) {
      return value;
    } else if (value) {
      return "0" + value;
    }
    return "0";
  }

  private setFromToDatesFromStart(date) {
    var month1 = date.getMonth();
    this.fromDate =
      date.getFullYear() +
      "-" +
      this.checklength(month1 + 1) +
      "-" +
      this.checklength(date.getDate());
    date.setDate(date.getDate() + 1);
    var month2 = date.getMonth();
    this.toDate =
      date.getFullYear() +
      "-" +
      this.checklength(month2 + 1) +
      "-" +
      this.checklength(date.getDate());
  }

  checkselectedtab(selectedTab) {
    if (selectedTab === "today") {
      sessionStorage.setItem("currentTab", "today");
      var date = new Date();
      this.setFromToDatesFromStart(date);
    } else if (selectedTab == "tomorrow") {
      sessionStorage.setItem("currentTab", "tomorrow");
      var date = new Date();
      date.setDate(date.getDate() + 1);
      this.setFromToDatesFromStart(date);
    } else if (selectedTab == "yesterday") {
      sessionStorage.setItem("currentTab", "yesterday");
      var date = new Date();
      date.setDate(date.getDate() - 1);
      this.setFromToDatesFromStart(date);
    } else if (selectedTab == "dayafter") {
      sessionStorage.setItem("currentTab", "dayafter");
      var date = new Date();
      date.setDate(date.getDate() + 2);
      this.setFromToDatesFromStart(date);
    }

    this.viewMessageCenter();
    this.gettingDataForTmrw();
  }

  gettingDataForTmrw() {
    this.appService.viewMessageCenter(this.toDate, this.toDate).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.preAuthorizedtmrwCount = res["entity"].preAuthorizedCount;
          this.nonAuthorizedtmrwCount = res["entity"].nonAuthorizedCount;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  viewMessageCenter() {
    this.appService.viewMessageCenter(this.fromDate, this.fromDate).subscribe(
      (res) => {
        if (res && res["status"] && res["status"]["status"] == 200) {
          this.preAuthorizedtodayCount = res["entity"].preAuthorizedCount;
          this.nonAuthorizedtodayCount = res["entity"].nonAuthorizedCount;
          this.patientCancelledCount = res["entity"].patientCancelledCount;
          this.patientNoShowCount = res["entity"].patientNoShowCount;
          this.rescheduledCount = res["entity"].rescheduledCount;
          this.icCancelledCount = res["entity"].icCancelledCount;
        }
      },
      (err) => {
        this.appService.sessionOut(err);
      }
    );
  }

  redirectToReschedule(type) {
    this.router.navigate([
      localStorage.getItem("testCode").toString().trim(),
      "rescheduled-patient",
    ]);
  }
}
